<template>
  <v-container grid-list-xs class="pa-2">
    <v-layout row wrap>
      <v-flex :class="toolClass">
        <v-btn icon class="ma-0" :title="$t('add-note')" v-if="!locked" @click="addNote">
          <v-icon>note_add</v-icon>
        </v-btn>
        <v-chip small label outlined :color="chipColor">IDX {{ index }}</v-chip>
      </v-flex>
      <v-flex :class="labelClass">
        {{ translatedLabel }}
      </v-flex>
      <v-flex :class="inputClass">
        <v-text-field
          @wheel.prevent=""
          v-model="rawValue"
          :label="$t('value')"
          :suffix="unit"
          :error="!valid"
          :disabled="locked"
          type="number"
          class="pt-0"
        ></v-text-field>
      </v-flex>
      <v-flex sx12 order-xs4 v-if="translatedDescription">
        <p><v-icon small>info</v-icon> {{ translatedDescription }}</p>
      </v-flex>
      <v-flex xs12 order-xs5 :style="noteStyle">
        <v-textarea
          v-model="note"
          :label="$t('note')"
          :disabled="locked"
          rows="1"
          auto-grow
          clearable
        ></v-textarea>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import validationMixin from './checklist-input-validation-mixin.es6'
import translationMixin from './checklist-translation-mixin.es6'
import noteMixin from './checklist-note-mixin.es6'

export default {
  name: 'checklist-input-number',
  mixins: [validationMixin, translationMixin, noteMixin],
  props: {
    index: Number,
    label: String,
    description: String,
    validations: Array,
    default: Object,
    source: Object,
    length: String
  },
  data () {
    // initial state
    return {
      rawValue: null
    }
  },
  created () {
    const { value, note } = this.default
    // set default value
    if (/number/.test(typeof value)) {
      this.rawValue = value
    }
    // set user note
    if ((/string/).test(typeof note)) {
      this.note = note
    }
  },
  computed: {
    value () {
      if (this.rawValue === '' || this.rawValue === null) {
        return null
      }
      return Number(this.rawValue)
    },
    valid () {
      if (this.value === null) {
        return true
      }

      if (isNaN(this.value)) {
        return false
      }

      if (this.validations.length === 0) {
        return true
      }

      return this.validate(this.value).valid
    },
    unit () {
      return this.source ? this.source.displayUnit : null
    },
    locked () {
      return this.$store.getters['checklist/isLocked']
    },
    toolClass () {
      const { breakpoint } = this.$vuetify
      if (this.length === 'narrow') {
        return {
          'text-right grey--text text--darken-2': true,
          'xs12': true
        }
      } else {
        return {
          'text-right grey--text text--darken-2': true,
          'xs12': breakpoint.xs,
          'sm6': breakpoint.sm,
          'md3': breakpoint.mdAndUp,
          'order-xs1': breakpoint.xs,
          'order-sm2': breakpoint.sm,
          'order-md3': breakpoint.mdAndUp
        }
      }
    },
    labelClass () {
      const { breakpoint } = this.$vuetify
      if (this.length === 'narrow') {
        return {
          'subtitle-1 pt-2': true,
          'xs12': true
        }
      } else {
        return {
          'subtitle-1 mt-3 pt-1': true,
          'xs12': breakpoint.xs,
          'sm6': breakpoint.sm,
          'md6': breakpoint.mdAndUp,
          'order-xs2': breakpoint.xs,
          'order-sm1': breakpoint.sm,
          'order-md2': breakpoint.mdAndUp
        }
      }
    },
    inputClass () {
      const { breakpoint } = this.$vuetify
      if (this.length === 'narrow') {
        return {
          'xs12 mt-2': true
        }
      } else {
        return {
          'mt-2': true,
          'xs12': breakpoint.xs,
          'sm12': breakpoint.sm,
          'md3': breakpoint.mdAndUp,
          'order-xs3': breakpoint.xs,
          'order-sm3': breakpoint.sm,
          'order-md1': breakpoint.mdAndUp
        }
      }
    }
  },
  watch: {
    value (value) {
      this.$emit('value', {
        value,
        valid: this.valid
      })
    },
    default: {
      handler ({ value, note }) {
        this.rawValue = value
        if (note !== null) {
          this.note = note
        }
      },
      deep: true
    }
  }
}
</script>
